import { render, staticRenderFns } from "./PayPass.vue?vue&type=template&id=c3c4b496&scoped=true&"
import script from "./PayPass.vue?vue&type=script&lang=js&"
export * from "./PayPass.vue?vue&type=script&lang=js&"
import style0 from "./PayPass.vue?vue&type=style&index=0&id=c3c4b496&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c4b496",
  null
  
)

export default component.exports